import {
	GlobalEmailTemplate,
	GlobalEmailTemplateMetadata,
} from '@models/global-email-templates';
import { createModelSelector, createSelector } from '@ngxs/store';
import { EmailTemplatesSelectors } from '@state/email-templates/email-templates.selectors';
import { TagsSelector } from '@state/global/tags/tags.selector';
import { UserProfileState } from '@state/user-profile';

export interface EmailTemplateSelectedTemplate {
	metadata: GlobalEmailTemplateMetadata;
	version: GlobalEmailTemplate;
}

export class EmailTemplateSelectors {
	static $selectedTemplateMetadata = createSelector(
		[EmailTemplatesSelectors.$selectedEmailTemplate],
		(template) => {
			return template.metadata;
		},
	);

	static $selectedTemplateVersion = createSelector(
		[EmailTemplatesSelectors.$selectedEmailTemplate],
		(template) => {
			return template.version;
		},
	);
	static $selectedTemplateName = createSelector(
		[EmailTemplateSelectors.$selectedTemplateMetadata],
		(metadata) => metadata.templateName,
	);
}

export const emailTemplateViewModel = createModelSelector({
	canEdit: UserProfileState.$canEditCloserEmailTemplates,
	template: EmailTemplatesSelectors.$selectedEmailTemplate,
	tagOptions: TagsSelector.$emailTemplateTagOptions,
});
